export enum CheckoutStatus {
  CheckoutScreen = 1,
  CustomerInformationAdded = 2,
  ShippingMethodAdded = 3,
  BillingInformationAdded = 4,
  Complete = 5
}
